import React from 'react';
import MUIDeleteIcon from '@mui/icons-material/Delete';
import { SvgIconProps } from '@mui/material/SvgIcon';

const DeleteIcon = ({
  color = 'primary',
}: SvgIconProps) => <MUIDeleteIcon color={color} />;

export default DeleteIcon;
